// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"20":"4a69325c","198":"c56dcc0a","275":"7fc6da6f","394":"2f981109","436":"e66d9ec5","496":"be90ca37","518":"77f1c47b","733":"cca0923d","965":"efb68d70"}[chunkId] + ".chunk.js";
};